var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{attrs:{"id":"burst-12"}},[_c('p',{staticClass:"percent text-sm"},[_vm._v(_vm._s(_vm.percent)+"% off")])])
}
var staticRenderFns = []

export { render, staticRenderFns }